<div class="score-gauge" [class.score-gauge--full]="arc === 'full'">
  <svg [attr.viewBox]="viewBox" class="score-gauge__svg">
    <!-- Track -->
    <path
      [attr.d]="arcPath"
      class="score-gauge__track"
      pathLength="100"
    ></path>

    <!-- Filled portion -->
    <!-- stroke is bound as a style, not an attribute: SVG presentation
         attributes do not resolve the var() that scoreColor returns. -->
    <path
      *ngIf="hasValue"
      [attr.d]="arcPath"
      [style.stroke]="arcColor"
      [attr.stroke-dashoffset]="dashOffset"
      class="score-gauge__value-arc"
      pathLength="100"
      stroke-dasharray="100"
    ></path>

    <g [attr.transform]="'translate(100 ' + textY + ')'">
      <text class="score-gauge__value" y="0" text-anchor="middle">
        {{ valueText }}
      </text>
      <text
        *ngIf="caption"
        class="score-gauge__caption"
        y="20"
        text-anchor="middle"
      >
        {{ caption }}
      </text>
    </g>
  </svg>

  <i
    *ngIf="icon"
    class="fa score-gauge__icon"
    [ngClass]="icon"
    aria-hidden="true"
  ></i>
</div>
